import FormValidator from "../../../inc/FormValidator";
import store from '../../../store';
class GridValidator extends FormValidator {
    constructor(fieldConfig = {}){
        super(fieldConfig = [fieldConfig],store.getState().language);
    }
}

export default GridValidator;